import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsInsurancePromocodeBody,
  PostApplicationsInsurancePromocodeResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsInsurancePromocode = createAsyncThunk<
  PostApplicationsInsurancePromocodeResponse,
  PostApplicationsInsurancePromocodeBody
>("applications/postApplicationsInsurancePromocode", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsInsurancePromocode(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications insurance promocode", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications insurance promocode", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});